import React from 'react';

import Input from 'common-ui/input';
import { AsyncSelect } from 'common-ui/select';

import { DURATION_OPTIONS } from '../../ActionPlanConstans';
import {
  FormGrid,
  FormGroup,
  KpiContainer,
  KpiHeader,
  KpiIcon,
  KpiTitle,
  QuantityContainer,
  Title,
} from '../EmployeeSteps.styles';

const Step3KpiConfig = ({
  formData,
  errors,
  submitted,
  isReadOnly,
  handleKpiChange,
  showQuantityProps = false,
  showDuration = true,
  showTitle = true,
}) => {
  const estType = formData.estimationType?.value;
  const showQuantity = estType === 'quantity' || estType === 'both';
  const showFinancial = estType === 'financial' || estType === 'both';

  return (
    <>
      {showTitle && <Title>Configure KPI Thresholds</Title>}
      {showDuration && (
        <FormGroup className="form-kpi">
          <AsyncSelect
            label="Duration*"
            disabled={isReadOnly}
            defaultOptions
            loadOptions={(inputValue, callback) => {
              callback(
                DURATION_OPTIONS.filter((opt) =>
                  opt.label.toLowerCase().includes((inputValue || '').toLowerCase())
                )
              );
            }}
            value={formData.kpiConfig.duration}
            onChange={(val) => handleKpiChange('duration', val)}
            $error={errors['kpiConfig.duration']}
          />
        </FormGroup>
      )}

      {showQuantity && (
        <QuantityContainer>
          <KpiHeader>
            <KpiIcon className="kpiIconQuantity">#</KpiIcon>
            <KpiTitle>Quantity KPI</KpiTitle>
          </KpiHeader>

          <FormGrid className="three-columns">
            <FormGroup>
              <Input
                label="Low Count"
                required
                type="number"
                placeholder="0.00"
                disabled={isReadOnly}
                value={formData.kpiConfig.qLowAmount}
                onChange={(e) => handleKpiChange('qLowAmount', e.target.value)}
                error={errors['kpiConfig.qLowAmount']}
                onWheel={(e) => e.target.blur()}
              />
            </FormGroup>
            <FormGroup>
              <Input
                label="Target Count"
                required
                type="number"
                placeholder="0.00"
                disabled={isReadOnly}
                value={formData.kpiConfig.qTargetAmount}
                onChange={(e) => handleKpiChange('qTargetAmount', e.target.value)}
                error={errors['kpiConfig.qTargetAmount']}
                onWheel={(e) => e.target.blur()}
              />
            </FormGroup>
            <FormGroup>
              <Input
                label="High Count"
                required
                type="number"
                placeholder="0.00"
                disabled={isReadOnly}
                value={formData.kpiConfig.qHighAmount}
                onChange={(e) => handleKpiChange('qHighAmount', e.target.value)}
                error={errors['kpiConfig.qHighAmount']}
                onWheel={(e) => e.target.blur()}
              />
            </FormGroup>
          </FormGrid>
        </QuantityContainer>
      )}

      {showFinancial && (
        <KpiContainer>
          <KpiHeader>
            <KpiIcon>$</KpiIcon>
            <KpiTitle>Financial KPI</KpiTitle>
          </KpiHeader>

          <FormGrid className="form-currency">
            <FormGroup className="form-max-width">
              <AsyncSelect
                label="Currency"
                req
                disabled={isReadOnly}
                defaultOptions
                loadOptions={(inputValue, callback) => {
                  const options = [
                    { value: 'AMD', label: 'AMD' },
                    { value: 'USD', label: 'USD' },
                    { value: 'EUR', label: 'EUR' },
                  ];
                  callback(
                    options.filter((opt) =>
                      (opt.label || '')
                        .toLowerCase()
                        .includes((inputValue || '').toLowerCase())
                    )
                  );
                }}
                value={formData.kpiConfig.currency}
                onChange={(val) => handleKpiChange('currency', val)}
                $error={errors['kpiConfig.currency']}
              />
            </FormGroup>
          </FormGrid>

          <FormGrid className="three-columns">
            <FormGroup>
              <Input
                label="Low Amount"
                required
                type="number"
                placeholder="0.00"
                value={formData.kpiConfig.lowAmount}
                onChange={(e) => handleKpiChange('lowAmount', e.target.value)}
                error={submitted ? errors['kpiConfig.lowAmount'] : null}
                onWheel={(e) => e.target.blur()}
              />
            </FormGroup>
            <FormGroup>
              <Input
                label="Target Amount"
                required
                type="number"
                placeholder="0.00"
                value={formData.kpiConfig.targetAmount}
                onChange={(e) => handleKpiChange('targetAmount', e.target.value)}
                error={submitted ? errors['kpiConfig.targetAmount'] : null}
                onWheel={(e) => e.target.blur()}
              />
            </FormGroup>
            <FormGroup>
              <Input
                label="High Amount"
                required
                type="number"
                placeholder="0.00"
                value={formData.kpiConfig.highAmount}
                onChange={(e) => handleKpiChange('highAmount', e.target.value)}
                error={submitted ? errors['kpiConfig.highAmount'] : null}
                onWheel={(e) => e.target.blur()}
              />
            </FormGroup>
          </FormGrid>
        </KpiContainer>
      )}
    </>
  );
};

export default Step3KpiConfig;
